import React, { useEffect } from 'react';
import { Loader2, Brain } from 'lucide-react';
import { useUserIntelligence } from '../../hooks/useUserIntelligence';
import UserIntelligenceForm from '../../components/intelligence/UserIntelligenceForm';
import IntelligenceDisplay from '../../components/intelligence/IntelligenceDisplay';
import IntelligenceInfoBox from '../../components/intelligence/IntelligenceInfoBox';

export default function UserIntelligence() {
  const {
    intelligence,
    inputData,
    setInputData,
    loading,
    generating,
    updating,
    exists,
    error,
    successMessage,
    loadUserIntelligence,
    createIntelligence,
    updateIntelligence,
    regenerateIntelligence
  } = useUserIntelligence();

  useEffect(() => {
    loadUserIntelligence();
  }, []);

  const handleGenerate = () => createIntelligence(inputData);
  const handleUpdate = () => updateIntelligence(inputData);
  const handleRegenerate = () => regenerateIntelligence(inputData);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#F8F7F4' }}>
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" style={{ color: '#FF6B5A' }} />
          <p style={{ color: '#0A0A10' }}>Loading your intelligence...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F7F4' }}>
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 107, 90, 0.15)' }}>
              <Brain className="w-6 h-6" style={{ color: '#FF6B5A' }} />
            </div>
            <h1 className="text-4xl font-bold" style={{ color: '#0A0A10' }}>
              Your Intelligence Profile
            </h1>
          </div>
          <p className="text-xl" style={{ color: '#0A0A10', opacity: 0.7 }}>
            Build and manage your personalized AI intelligence based on your communication style
          </p>
        </div>

        {/* Success/Error Messages */}
        {successMessage && (
          <div className="mb-6 p-4 rounded-lg border" style={{ backgroundColor: 'rgba(215, 180, 114, 0.15)', borderColor: '#D7B472' }}>
            <p style={{ color: '#0A0A10' }}>✓ {successMessage}</p>
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 rounded-lg border" style={{ backgroundColor: 'rgba(255, 107, 90, 0.15)', borderColor: '#FF6B5A' }}>
            <p style={{ color: '#FF6B5A' }}>✗ {error}</p>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Input Section */}
          <UserIntelligenceForm
            inputData={inputData}
            onInputChange={setInputData}
            onGenerate={handleGenerate}
            onUpdate={handleUpdate}
            onRegenerate={handleRegenerate}
            generating={generating}
            updating={updating}
            exists={exists}
            showActions={true}
          />

          {/* Intelligence Display Section */}
          <IntelligenceDisplay intelligence={intelligence} />
        </div>

        {/* Info Section */}
        <div className="mt-8">
          <IntelligenceInfoBox />
        </div>
      </div>
    </div>
  );
}
